export const VideoInHomepageHeroAbTestVariantA = 'A';
export const VideoInHomepageHeroAbTestVariantB = 'B';
